import { render, staticRenderFns } from "./FileEditorPop.vue?vue&type=template&id=28fa6ca7&scoped=true"
import script from "./FileEditorPop.vue?vue&type=script&lang=js"
export * from "./FileEditorPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa6ca7",
  null
  
)

export default component.exports